module.exports = __webpack_public_path__ + "b1e50a8049d8642e71d9f2677d81699e.MP3";